import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import pick from 'ramda/src/pick';
import pipe from 'ramda/src/pipe';
import moment from 'moment-timezone';
import { addBarber, saveBarberImage } from '../actions';
import { t } from '../../../../modules/infra/i18n';
import { getShopUserServices } from '../../services/actions';
import SimpleHeader from '../../headers/simpleHeader';
import BarberForm from '../formBarbers/barberForm';
import { generateDays, prepareSchedule } from '../../../common/helpers/schedules';
import { minServiceLenModel } from '../../../common/helpers/modelSettings';
import { activeShop } from '../../../auth/selectors';
import { parseMultiFieldValues } from '../../../common/helpers/times';
import withMinInterval from '../../../common/hoc/withMinInterval';

const getInitialValuesFromShop = pipe(
  pick([
    'bookNoPay',
    'tipEnabled',
    'allowMultipleServices',
    'minServiceLen',
    'bookingInterval',
    'advanceBookDays',
    'advanceBookMins',
    'advanceCancelMins',
    'customerReminder',
    'canCustomerCancel',
  ]),
  parseMultiFieldValues
);

class AddBarber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
      initialValues: {
        firstName: '',
        lastName: '',
        color: '#b6dff7',
        userEnabled: true,
        schedules: {
          current: {
            startDate: moment.utc().toDate(),
            workdays: generateDays(true),
          },
          future: {
            workdays: generateDays(),
          },
        },
        notifications: {
          confirm: {
            email: true,
            phone: false,
            push: true,
          },
          reschedule: {
            email: false,
            phone: true,
            push: true,
          },
          cancel: {
            email: false,
            phone: true,
            push: true,
          },
          reminder: {
            email: true,
            phone: false,
            push: true,
            time: {
              hours: 0,
              minutes: 45,
            },
          },
          arrived: {
            email: false,
            phone: true,
            push: true,
          },
        },
        permissions: {
          appointments: {
            view: true,
            show_contact_info: true,
            book: true,
            modify: true,
            history: true,
            blockTime: true,
          },
          clients: {
            view: true,
            add: true,
            modify: true,
          },
          services: {
            view: true,
            add: true,
            modify: true,
          },
          workHours: {
            view: true,
            add: true,
            modify: true,
          },
          bankAccount: {
            view: true,
            add: true,
            modify: true,
          },
          profile: {
            view: true,
            modify: true,
          },
          reports: {
            view: true,
          },
          customCharge: {
            view: true,
          },
          autoPayout: {
            view: true,
          },
          engage: {
            view: false,
          },
        },
        advanceBookDays: 60,
        advanceBookMins: {
          hours: 0,
          minutes: 30,
        },
        advanceCancelMins: {
          hours: 1,
          minutes: 0,
        },
        allowMultipleServices: true,
        enabled: true,
        remindCustomers: {
          hours: 1,
          minutes: 0,
        },
        minServiceLen: props.minInterval,
        bookingInterval: props.minInterval,
        depositSettings: {},
      },
      useShopServices: true,
    };
  }

  componentWillMount() {
    if (this.props.shop) {
      this.setInitialValuesFromShop(this.props.shop);
    }
  }

  componentDidMount() {
    if (this.props.shop) {
      this.fetchServices(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.shop && nextProps.shop) {
      this.fetchServices(nextProps);
    }
  }

  setInitialValuesFromShop = (shop) => {
    const fromShop = getInitialValuesFromShop(shop);

    let { schedules } = shop;

    schedules = prepareSchedule(schedules);

    if (!schedules.current) {
      schedules.current = {
        startDate: moment.utc().toDate(),
        workdays: generateDays(),
      };
    } else {
      delete schedules.current.id; // unique ID taken from shop schedule. API will assign a new ID
    }
    if (!schedules.future) {
      schedules.future = {
        workdays: generateDays(),
      };
    } else {
      delete schedules.future.id; // unique ID taken from shop schedule. API will assign a new ID
    }

    this.setState({
      initialValues: {
        ...this.state.initialValues,
        ...fromShop,
      },
    });
  };

  saveBarber = (data) => {
    const { saveBarber, shop, router, minInterval } = this.props;

    let avatar = null;
    const model = minServiceLenModel(data, minInterval);
    model.shopId = shop.id;
    if (model.avatar) {
      avatar = model.avatar;
      delete model.avatar;
    }

    return saveBarber(model)
      .then((barber) => {
        if (!avatar) {
          router.push('/barbers');
          return Promise.resolve();
        }
        return this.props
          .saveBarberImage(barber.barberId, avatar)
          .then(() => {
            router.push('/barbers');
          })
          .catch((error) => {
            this.setState({
              errors: error.message,
            });
          });
      })
      .catch((error) => {
        this.setState({
          errors: error.message,
        });
      });
  };

  async fetchServices(props) {
    const { fetchShopServices, shop } = props;
    let initialValues = { ...this.state.initialValues };
    let { useShopServices } = this.state;

    await fetchShopServices(shop.id).then((serviceList) => {
      const services = serviceList.map((service) => ({
        ...service,
        id: service.originalId,
        visibleOnline: service.enabled,
        enabled: false,
      }));
      useShopServices = true;
      initialValues = Object.assign(initialValues, { services });
    });
    this.setState({ initialValues, useShopServices });
  }

  render() {
    const { initialValues, useShopServices, errors } = this.state;

    return (
      <div>
        <SimpleHeader heading={t('barber:add_barber.heading')} />
        <div className="c-wrapper">
          <div className="u-margin-auto u-max-width-710" display-if={errors}>
            <div className="c-login-error-message u-mb u-mt">{errors}</div>
          </div>
          <BarberForm
            saveBarber={this.saveBarber}
            useShopServices={useShopServices}
            initialValues={initialValues}
            className="u-margin-auto u-color-white u-max-width-710"
            showUsername
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shop: activeShop(state),
  timezone: state.auth.timezone,
});

const mapDispatchToProps = {
  saveBarber: addBarber,
  fetchShopServices: getShopUserServices,
  saveBarberImage,
};

AddBarber.propTypes = {
  shop: PropTypes.object.isRequired,
  saveBarber: PropTypes.func.isRequired,
  saveBarberImage: PropTypes.func.isRequired,
  fetchShopServices: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  minInterval: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withMinInterval(AddBarber)));
